import { render, staticRenderFns } from "./EmployeeOverview.vue?vue&type=template&id=709a461d&scoped=true&"
import script from "./EmployeeOverview.vue?vue&type=script&lang=js&"
export * from "./EmployeeOverview.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeOverview.vue?vue&type=style&index=0&id=709a461d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709a461d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VIcon,VRow})
